import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    ...theme.mixins.appClickableContainer,
    ...theme.mixins.appContainersSpacing,
    cursor: 'default',
    '&:hover': {
      borderColor: 'transparent',
    },
  },
  infoWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  contentRow: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
    width: '100%',
  },
  leftBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1,
    minWidth: 0,
  },
  avatarSkeleton: {
    flexShrink: 0,
  },
  titleSkeleton: {
    width: '100%',
    maxWidth: '70%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
    },
  },
  iconsBlock: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
    flexShrink: 0,
  },
  iconSkeleton: {
    flexShrink: 0,
  },
}));
